import React from "react";
import "./Investments.css";
import rehla from "../../assets/icons/investmentsIcons/rehlaIcon.svg";
import saudiElan from "../../assets/icons/investmentsIcons/saudiElanIcon.svg";
import uvera from "../../assets/icons/investmentsIcons/uveraIcon.svg";
import regard from "../../assets/icons/investmentsIcons/regardaIcon.svg";
import lead from "../../assets/icons/investmentsIcons/leadIcon.svg";
import velents from "../../assets/icons/investmentsIcons/velentsIcon.svg";
import edama from "../../assets/icons/investmentsIcons/edamaIcon.svg";
import nama from "../../assets/icons/investmentsIcons/namaIcon.svg";
import gbo from "../../assets/icons/investmentsIcons/gboIcon.svg";
import darcaif from "../../assets/icons/investmentsIcons/darcaifIcon.svg";
import moneymoon from "../../assets/icons/investmentsIcons/moneymoon.png";
import whitefooter from "../../assets/whitefooter.svg";
import hakbah from "../../assets/icons/hakbah.png";
import point2 from "../../assets/whitepoint.svg";
import lawazem from "../../assets/icons/investmentsIcons/lawazem.svg";
import valley from "../../assets/icons/valley.png";
import dit from "../../assets/icons/DIT.png";
import waja from "../../assets/icons/wajarealestate.png";
import arktech from "../../assets/icons/arktech.png";
import jasara2 from "../../assets/22.png";
import waheedbg from "../../assets/icons/bg.svg";
import { useTranslation } from "react-i18next";

const investmentLogos = [
  {
    src: hakbah,
    alt: "Hakbah",
    href: "https://hakbah.sa/",
  },
  {
    src: waja,
    alt: "Waja",
    href: "https://waja.sa/",
    className: "logo-white logo-waja",
  },
  {
    src: arktech,
    alt: "Arktech",
    href: "https://arktec.sa/",
    className: "logo-white logo-arktech",
  },
  {
    src: valley,
    alt: "Valley",
    href: "https://valie.sa/",
    className: "logo-white logo-valley",
  },
  {
    src: dit,
    alt: "DIT",
    href: "https://www.dit.sa/",
    className: "logo-white logo-dit",
  },
  {
    src: jasara2,
    alt: "Jasara",
    href: "https://jasarh.sa/",
    className: "logo-white logo-jasara",
  },
  {
    src: rehla,
    alt: "Rehla",
    href: "https://rehlacar.com/",
  },
  {
    src: uvera,
    alt: "Uvera",
    href: "https://www.uvera.co/",
  },
  {
    src: saudiElan,
    alt: "Saudi Elan",
    href: "https://saudielan.org",
  },
  {
    src: regard,
    alt: "Regard",
    href: "https://www.regards.sa/",
  },
  {
    src: lead,
    alt: "Lead",
  },
  {
    src: velents,
    alt: "Velents",
    href: "https://velents.ai/",
  },
  {
    src: edama,
    alt: "Edama",
    href: "http://www.edama.com.sa/",
  },
  {
    src: nama,
    alt: "Nama",
    href: "https://namare.sa/",
  },
  {
    src: gbo,
    alt: "GBO",
    href: "https://gbo.sa/",
  },
  {
    src: darcaif,
    alt: "Dar Caif",
    href: "https://www.instagram.com/dar_caif/?hl=ar",
  },
  {
    src: moneymoon,
    alt: "Moneymoon",
    href: "https://moneymoon.sa/",
  },
  {
    src: lawazem,
    alt: "Lawazem",
    href: "https://www.lawazem.com/",
  },
];

export default function Investments() {
  const { t } = useTranslation();

  return (
    <section id="investments">
      <div
        style={{
          height: "auto",
          background: "#022539",
          paddingBottom: "30px",
        }}
      >
        <div className="title-container">
          <img src={point2} className="bulletPoint" alt="" />
          <h1 className="my-investments">{t("my_investments")}</h1>
          <img src={point2} className="bulletPoint" alt="" />
        </div>

        <div className="investment-container">
          <img src={waheedbg} alt="bg" className="waheed-bg" />

          <div className="investments-icons">
            {investmentLogos.map((logo) => {
              const image = (
                <img src={logo.src} alt={logo.alt} className={logo.className} />
              );

              if (logo.href) {
                return (
                  <a
                    key={logo.alt}
                    href={logo.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="investment-logo"
                  >
                    {image}
                  </a>
                );
              }

              return (
                <div key={logo.alt} className="investment-logo">
                  {image}
                </div>
              );
            })}
          </div>

          <img src={whitefooter} alt="white-footer" className="white-footer" />
        </div>
      </div>
    </section>
  );
}
